import { addressLabel } from "./addressLabel";

/**
 * Display text for an Address object, "N/A" when there's nothing to show.
 * Delegates to `addressLabel`, which prefers `fullAddress`, then the
 * structured parts, then the user-typed `displayAddress` / `input_address`
 * (the only fields a failed geocode leaves populated).
 *
 * `displayFullAddress` is kept for call-site compatibility; the resolution
 * order is the same either way now.
 */
export const formatAddressObjectFullAddress = (
  address,
  // eslint-disable-next-line no-unused-vars
  displayFullAddress = false,
) => addressLabel(address, "N/A");
